<template>
  <div class="page-container">
    <div class="page-header">
      <div class="d-flex align-items-center w-100">
        <b-button variant="link" class="mr-3" @click="onBack()">
          <v-icon name="buttons/chevrons_left" :size="13"/>
        </b-button>
        <h4 class="mb-0">{{title}}</h4>
        <b-button class="custom-btn-primary ml-auto" :disabled="isDisabled || loading" @click="handleSubmit()">
          <b-spinner v-if="loading" small/>
          <v-icon name="buttons/check" :size="13"/>
          Сохранить
        </b-button>
      </div>
    </div>

    <div class="page-body" style="overflow-y: auto;">
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-tabs card class="custom-tab">
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/user" :size="13" class="mr-2"/>
                <span>Персональные данные</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/payment_card" :size="13" class="mr-2"/>
                <span>Платёжные реквизиты</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/passport" :size="13" class="mr-2"/>
                <span>Паспортные данные</span>
              </template>
            </b-tab>
            <b-tab v-if="isVisibleForRole()" disabled>
              <template #title>
                <v-icon name="buttons/payment" :size="13" class="mr-2"/>
                <span>Расходы</span>
              </template>
            </b-tab>
            <b-tab v-if="isVisibleForRole()" disabled>
              <template #title>
                <v-icon name="navbar/link" :size="13" class="mr-2"/>
                <span>Связи</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="navbar/tasks" :size="13" class="mr-2"/>
                <span>Последние заявки</span>
              </template>
            </b-tab>
            <b-tab disabled>
              <template #title>
                <v-icon name="buttons/file" :size="13" class="mr-2"/>
                <span>Медиафайлы</span>
              </template>
            </b-tab>
          </b-tabs>
          <!-- Персональные данные -->
          <b-card class="custom-card mb-2">
            <b-row>
              <b-col>
                <b-skeleton width="10%" height="16%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
              </b-col>
              <b-col>
                <b-skeleton width="10%" height="16%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
              </b-col>
              <b-col>
                <b-skeleton width="10%" height="16%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="29%" class="mb-2"/>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="6%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="6%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="6%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
          </b-card>
          <b-card class="custom-card mb-2">
            <b-row class="mb-2">
              <b-col>
                <b-skeleton width="6%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="6%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="6%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
          </b-card>
          <b-card class="custom-card mb-2">
            <b-row class="mb-2 pt-1">
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
          </b-card>
          <b-card class="custom-card mb-2">
            <b-row class="mb-2 pt-1">
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-skeleton width="17%" height="24%" class="mb-2"/>
                <b-skeleton type="input" width="100%" height="45%"/>
              </b-col>
            </b-row>
          </b-card>
        </template>

        <template #default>
          <b-form @submit.stop.prevent="handleSubmit">
            <b-tabs card class="custom-tabs">
              <b-tab active>
                <template #title>
                  <v-icon name="navbar/user" :size="13" class="mr-2"/>
                  <span>Персональные данные</span>
                </template>
                <b-card class="custom-card mb-2">
                  <h6 class="text-muted text-small">ОСНОВНАЯ ИНФОРМАЦИЯ</h6>
                  <b-row>
                    <b-col>
                      <b-form-group id="group-name" label="ФИО">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :state="getFieldState('name')"
                          :placeholder="$t('message.workers.modal.namePlaceholder')"
                          v-model="newItem.name"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-age" label="Пол">
                        <b-form-select
                          size="sm"
                          :disabled="isDisabled"
                          v-model="newItem.sex"
                        >
                          <option :value="null" disabled>Выберите пол</option>
                          <option :value="true">Мужчина</option>
                          <option :value="false">Женщина</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group id="group-age" label="Возраст">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите возраст"
                          v-model="newItem.age"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group id="group-town" label="Город">
                        <town-select
                          :value="newItem.town_id"
                          @onSelect="onSelectTown"
                          :is-disabled="isDisabled"
                          :state="getFieldState('town_id')"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-address" label="Адрес проживания">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.addressPlaceholder')"
                          v-model="newItem.address"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group label="Телефон">
                        <b-input-group size="sm" :prepend="phoneInputPrefix(newItem.phone)">
                          <b-form-input
                            size="sm"
                            type="tel"
                            :disabled="isDisabled"
                            :placeholder="$t('message.workers.modal.phonePlaceholder')"
                            :state="phoneState"
                            v-model="newItem.phone"
                          />
                          <b-form-invalid-feedback :state="phoneState">
                            {{phoneInvalidFeedback}}
                          </b-form-invalid-feedback>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card class="custom-card mb-2">
                  <h6 class="text-muted text-small">ДОКУМЕНТЫ И СТАТУС</h6>
                  <b-row>
                    <b-col cols="3">
                      <b-form-group id="group-inn" label="ИНН">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите ИНН"
                          v-model="newItem.inn"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="3">
                      <b-form-group id="group-snils" label="СНИЛС">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите СНИЛС"
                          v-model="newItem.snils"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="3">
                      <b-form-group id="group-passport-type" label="Гражданство">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.passport_typePlaceholder')"
                          v-model="newItem.passport_type"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="3">
                      <b-form-group id="group-employment-type" label="Тип занятости">
                        <base-select
                          :is-disabled="isDisabled"
                          :state="getFieldState('employment_type')"
                          :options="employmentTypes"
                          :value="newItem.employment_type"
                          placeholder="Выберите тип занятости"
                          @onSelect="onSelectEmploymentType"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card class="custom-card mb-2">
                  <h6 class="text-muted text-small">ДЕТАЛИ РАБОТЫ</h6>
                  <b-row>
                    <b-col cols="4">
                      <b-form-group id="group-skills" :label="$t('message.workers.modal.skillInput')">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.skillPlaceholder')"
                          v-model="newItem.skill"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-ready" :label="$t('message.workers.modal.readyInput')">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          :placeholder="$t('message.workers.modal.readyPlaceholder')"
                          v-model="newItem.ready"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group label="Уровень КПД">
                        <base-select
                          :is-disabled="isDisabled"
                          :state="getFieldState('level_efficiency')"
                          :options="levelEfficiencyOptions"
                          :value="newItem.level_efficiency"
                          placeholder="Выберите уровень КПД"
                          @onSelect="onSelectLevelEfficiency"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card class="custom-card">
                  <h6 class="text-muted mb-0">ПРИМЕЧАНИЕ</h6>
                  <b-row>
                    <b-col>
                      <b-form-group id="group-status" label="Статус исполнителя">
                        <worker-status-select
                          :value="newItem.status_id"
                          @onSelect="onSelectWorkerStatus"
                          :is-disabled="isDisabled"
                          drop-up
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-worker-source" label="Источник">
                        <worker-source-select
                          :value="newItem.worker_source_id"
                          @onSelect="onSelectWorkerSource"
                          :is-disabled="isDisabled"
                          :state="getFieldState('worker_source_id')"
                          drop-up
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="4">
                      <b-form-group id="group-worker-source-comment" label="Источник комментарий">
                        <b-form-input
                          type="text"
                          size="sm"
                          :disabled="isDisabled"
                          v-model="newItem.worker_source_comment"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-form-group label="Комментарий">
                    <b-form-textarea
                      size="sm"
                      :disabled="isDisabled"
                      :placeholder="$t('message.workers.modal.descriptionPlaceholder')"
                      v-model="newItem.description"
                      :rows="4"
                      :max-rows="6"
                    />
                  </b-form-group>
                </b-card>
              </b-tab>

              <b-tab>
                <template #title>
                  <v-icon name="buttons/payment_card" :size="13" class="mr-2"/>
                  <span>Платёжные реквизиты</span>
                </template>
                <b-card class="custom-card">
                  <div class="d-flex mb-3">
                    <template v-for="(method, index) in paymentMethods">
                      <input
                        type="radio"
                        class="d-none"
                        :id="'method_' + method.id"
                        :value="method.id"
                        v-model="activePaymentId"
                      >
                      <label
                        :for="'method_' + method.id"
                        :class="[activePaymentId === method.id ? 'custom-btn-primary' : 'custom-btn-secondary','cursor-pointer mb-0']"
                        :style="{'border-radius': getBorderRadius(index, paymentMethods.length)}"
                      >
                        {{ method.name }}
                      </label>
                    </template>
                  </div>
                  <div v-if="activePaymentId === 1" key="form-sbp">
                    <b-form-group label="Телефон">
                      <b-input-group size="sm" :prepend="phoneInputPrefix(newItem.payments_sbp.sbp_phone)">
                        <b-form-input
                          id="sbp-phone"
                          type="tel"
                          size="sm"
                          :readonly="isDisabled"
                          :placeholder="$t('message.workers.modal.phonePlaceholder')"
                          v-model="newItem.payments_sbp.sbp_phone"
                        />
                      </b-input-group>
                    </b-form-group>
                    <b-form-group label="ФИО получателя">
                      <b-form-input
                        id="sbp-name"
                        size="sm"
                        :readonly="isDisabled"
                        v-model="newItem.payments_sbp.recipient_name"
                      />
                    </b-form-group>
                  </div>

                  <div v-else-if="activePaymentId === 2" key="form-card">
                    <b-form-group :label="$t('message.workers.modal.cart_numberInput')">
                      <b-form-input
                        id="card-number"
                        size="sm"
                        :readonly="isDisabled"
                        v-model="newItem.payments_card.card_number"
                      />
                    </b-form-group>
                  </div>

                  <div v-else-if="activePaymentId === 3" key="form-req">
                    <b-form-group label="Номер счёта">
                      <b-form-input
                        id="req-acc"
                        size="sm"
                        :readonly="isDisabled"
                        v-model="newItem.payments_req.account_number"
                      />
                    </b-form-group>
                    <b-form-group label="БИК">
                      <b-form-input
                        id="req-bik"
                        size="sm"
                        :readonly="isDisabled"
                        v-model="newItem.payments_req.bik"
                      />
                    </b-form-group>
                    <b-form-group label="ФИО получателя">
                      <b-form-input
                        id="req-name"
                        size="sm"
                        :readonly="isDisabled"
                        v-model="newItem.payments_req.recipient_name"
                      />
                    </b-form-group>
                  </div>
                </b-card>
              </b-tab>

              <b-tab>
                <template #title>
                  <v-icon name="buttons/passport" :size="13" class="mr-2"/>
                  <span>Паспортные данные</span>
                </template>
                <b-row>
                  <b-col lg="6">
                    <b-card class="custom-card">
                      <b-form-group id="group-passport-series" label="Серия">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите серию"
                          v-model="newItem.passport.passport_series"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-number" label="Номер">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите номер"
                          v-model="newItem.passport.passport_number"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-birthdate" label="Дата рождения">
                        <b-form-input
                          size="sm"
                          type="date"
                          :disabled="isDisabled"
                          v-model.date="newItem.passport.birth_date"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-birthplace" label="Место рождения">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите место рождения"
                          v-model="newItem.passport.birth_place"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-issued-by" label="Кем выдан">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите Кем выдан"
                          v-model="newItem.passport.issued_by"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-issue-date" label="Дата выдачи">
                        <b-form-input
                          size="sm"
                          type="date"
                          :disabled="isDisabled"
                          v-model.date="newItem.passport.issue_date"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-department-code" label="Код подразделения">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите Код подразделения"
                          v-model="newItem.passport.department_code"
                        />
                      </b-form-group>

                      <b-form-group id="group-passport-registration-address" label="Адрес регистрации">
                        <b-form-input
                          size="sm"
                          type="text"
                          :disabled="isDisabled"
                          placeholder="Введите Адрес регистрации"
                          v-model="newItem.passport.registration_address"
                        />
                      </b-form-group>
                    </b-card>
                  </b-col>
                  <b-col lg="6">
                    <b-card class="custom-card">
                      <b-form-group id="group-passport" :label="$t('message.workers.modal.passport_urlInput')">
                        <b-form-file
                          v-if="!isShowFile(newItem)"
                          ref="file_input"
                          size="sm"
                          :placeholder="$t('message.workers.modal.passport_urlPlaceholder')"
                          browse-text="Выбрать"
                          :disabled="isDisabled"
                          v-model="passportFile"
                        />
                        <div id="input-passport-file" v-if = isShowFile(newItem) style="display: flex;align-items: center;justify-content: left;">
                          <b-img
                            style="cursor: pointer"
                            thumbnail
                            width="100"
                            height="100"
                            :src="previewUrl"
                            @click="downloadFile"
                          />
                          <b-btn v-if="!isDisabled" variant="danger" size="sm" class="mx-2 md-0" @click="onRemove(newItem)">
                            {{ $t("message.common.searchClear") }}
                          </b-btn>
                        </div>
                      </b-form-group>
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab v-if="isVisibleForRole()">
                <template #title>
                  <v-icon name="buttons/payment" :size="13" class="mr-2"/>
                  <span>Расходы</span>
                </template>
                <worker-costs ref="worker_costs" :is-disabled="isDisabled"></worker-costs>
              </b-tab>
              <b-tab v-if="isVisibleForRole()">
                <template #title>
                  <v-icon name="navbar/link" :size="13" class="mr-2"/>
                  <span>Связи</span>
                </template>
                <b-row>
                  <b-col cols="6">
                    <b-card class="custom-card">
                      <b-form-group label="Штатный сотрудник">
                        <staff-select ref="staff_select" @onSelect="updateStaffId"/>
                      </b-form-group>
                    </b-card>
                  </b-col>
                  <b-col cols="6">
                    <b-card class="custom-card">
                      <b-form-group label="Интеграция Баланс ПРО">
                        <span class="text-secondary text-small" v-if="workerIntegration">
                          Идентификатор {{workerIntegration.balans_pro_id}}
                        </span>
                        <b-row no-gutters v-if="!workerIntegration">
                          <b-col cols="5">
                            <b-form-input
                              id="input-inn"
                              size="sm"
                              type="text"
                              :disabled="isDisabled"
                              placeholder="Введите ИНН для поиска"
                              v-model="innIntegration"
                            />
                          </b-col>
                          <b-col cols="5">
                            <organization-select
                              id="input-org-select"
                              ref="organization_select"
                              class="ml-1"
                              :value="0"
                              @onSelect="onSelectOrg"
                            />
                          </b-col>
                          <b-col cols="2">
                            <b-button class="custom-btn-secondary ml-1" @click="findBalansProWorkerHandler()">
                              Связать
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-button v-if="workerIntegration" size="sm" variant="danger" class="ml-3" @click="prepareUnlinkBalansProWorkerHandler()">
                          Отвязать
                        </b-button>
                      </b-form-group>
                    </b-card>
                  </b-col>
                </b-row>
              </b-tab>

              <b-tab>
                <template #title>
                  <v-icon name="navbar/tasks" :size="13" class="mr-2"/>
                  <span>Последние заявки</span>
                </template>
                <template v-if="isBusy || lastTasks.length > 0">
                  <div class="page-table-container">
                    <b-table
                      class="mb-0 custom-table"
                      :items="lastTasks"
                      :fields="lastTasksFields"
                    >
                      <template #cell(start_date)="row">
                        {{formatTableDateTime(row.item.start_date)}}
                      </template>
                    </b-table>
                  </div>
                </template>
                <div v-else class="empty-state-container">
                  <v-icon name="navbar/empty_table" :size="90"/>
                  <h5>Нет последних заявок</h5>
                </div>
              </b-tab>
              <b-tab>
                <template #title>
                  <v-icon name="buttons/file" :size="13" class="mr-2"/>
                  <span>Медиафайлы</span>
                </template>
                <worker-media ref="worker_media_files" :is-disabled="isDisabled" :worker-id="newItem.id"/>
              </b-tab>
            </b-tabs>
          </b-form>
        </template>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import workers from "../../network/workers";
import balansPro from "../../network/balansPro";
import recruitJobPostings from "../../network/recruitJobPostings";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
  import permissions, {PERM} from "../../utilites/permissions";
    import LocationCosts from "../Locations/LocationCosts.vue";
    import WorkerCosts from "../Workers/WorkerCosts.vue";
    import StaffSelect from "../Staff/StaffSelect.vue";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import VacancySelect from "../Catalogs/Vacancies/VacancySelect.vue";
    import WorkerStatusSelect from "../Catalogs/WorkerStatuses/WorkerStatusSelect.vue";
    import TownSelect from "../Catalogs/Towns/TownSelect.vue";
    import WorkerSourceSelect from "../Catalogs/WorkerSources/WorkerSourceSelect.vue";
    import BaseSelect from "../../utilites/commonUi/BaseSelect.vue";
    import WorkerMedia from "./WorkerMedia.vue";

export default {
  name: 'Worker',
  components: { WorkerMedia, BaseSelect, WorkerSourceSelect, TownSelect, WorkerStatusSelect, VacancySelect, StaffSelect, LocationCosts, WorkerCosts, OrganizationSelect },
  mixins: [
    workers, balansPro, recruitJobPostings,
    helpers, dateFormatter, permissions
  ],
  props: {
    worker_id: { type: Number, default: null },
    isRead: { type: Boolean, default: false },
    isModal: { type: Boolean, default: false },
    responseId: { type: Number, default: null },
  },
  data() {
    return {
      title:'Исполнитель',
      newItem: this.makeNewItem(),
      isDisabled: true,
      passportFile: null,
      previewUrl: null,
      isBusy: false,
      loading: false,
      employmentTypes: [
        { value: 1, text: 'СМЗ' },
        { value: 2, text: 'ГПХ' },
        { value: 3, text: 'ФЛ' },
        { value: 4, text: 'ИП' },
        { value: 5, text: 'В штате' },
      ],
      paymentFields: [
        {
          key: 'selected',
          class: 'worker-payment-width-selected',
        },
        {
          key: 'details',
        },
      ],
      activePaymentId: 1,
      paymentMethods: [
        { id: 1, name: 'Оплата через СБП'},
        { id: 2, name: 'Оплата по номеру карты'},
        { id: 3, name: 'Оплата по реквизитам счёта'},
      ],
      workerIntegration: null,
      innIntegration: "",
      selectedOrgId: null,
      levelEfficiencyOptions: [
        { value: 'high', text: 'Высокий' },
        { value: 'medium', text: 'Средний' },
        { value: 'low', text: 'Низкий' },
      ],
      lastTasks: [],
      lastTasksFields: [
        {
          key: 'task_id',
          label: 'Заявка №',
          class: 'text-center'
        },
        {
          key: 'start_date',
          label: 'Дата',
        },
        {
          key: 'executor_name',
          label: 'Ответственный',
        },
        {
          key: 'location_name',
          label: 'Объект',
        },
        {
          key: 'customer_name',
          label: 'Заказчик',
        },
        {
          key: 'price',
          label: 'Цена за ед.',
          formatter: 'priceFormat',
          class: 'text-center'
        },
        {
          key: 'total_units',
          label: 'Кол-во',
          class: 'text-center'
        },
        {
          key: 'total_price',
          label: 'Цена',
          formatter: 'priceFormat',
          class: 'text-center'
        },
        {
          key: 'total_price',
          label: 'Цена',
          class: 'text-center'
        },
      ]
    }
  },
  async created() {
    this.isBusy = true;
    this.loading = true;
    await this.updateView();

    await this.getLastTasks();
  },
  computed: {
    phoneState() {
      return /^\d{10}$/.test(this.newItem.phone);
    },
    phoneInvalidFeedback() {
      return 'Телефон должен состоять только из 10 цифр без пробелов и скобок.';
    },
  },
  watch: {
    passportFile(newFile) {
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }

      if (newFile instanceof File || newFile instanceof Blob) {
        this.previewUrl = URL.createObjectURL(newFile);
      }
    }
  },
  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  },
  methods: {
    getBorderRadius(index, total) {
      if (total === 1) return '6px !important';
      if (index === 0) return '6px 0 0 6px !important'; // Левый край
      if (index === total - 1) return '0 6px 6px 0 !important'; // Правый край
      return '0 !important'; // Середина
    },
    makeNewItem() {
      return {
        id: null,
        name: '',
        phone: '',
        address: '',
        age: '',
        sex: null,
        passport_type: '',
        passport_url: '',
        rating: 0.0,
        active_today: false,
        active: true,
        description: '',
        group_id: 1,
        skill: '',
        ready: '',
        town_id: null,
        worker_source_id: 0,
        worker_source_comment: '',
        inn: '',
        snils: '',
        active_payment_type: null,
        passport: this.makePassport(),
        payments_sbp: this.makeSBPPayment(),
        payments_card: this.makeCardPayment(),
        payments_req: this.makeReqPayment(),
        staff_id: null,
        employment_type: null,
        level_efficiency: 'high',
        status_id: null,
        status_name: null,
      }
    },
    makePassport() {
      return {
        passport_series: null,
        passport_number: null,
        birth_date: null,
        birth_place: null,
        issued_by: null,
        issue_date: null,
        department_code: null,
        registration_address: null,
      }
    },
    makeSBPPayment() {
      return {
        sbp_phone: null,
        recipient_name: null,
        bank_name: null,
      }
    },
    makeCardPayment() {
      return {
        card_number: null,
        recipient_name: null,
      }
    },
    makeReqPayment() {
      return {
        account_number: null,
        bik: null,
        bank_name: null,
        recipient_name: null,
      }
    },
    async updateView() {
      this.isDisabled = this.$props.isRead;

      const workerId = this.$route.params.worker_id;

      if (workerId) {
        await this.getWorker(workerId);
      } else {
        this.clearNewItem();
        this.isBusy = false;
        this.loading = false;
      }
    },
    configure(item) {
      this.clearNewItem();

      this.newItem.name = item.name || '';
      const phoneDigits = (item.phone || '').replace(/[^0-9]/g, '');
      this.newItem.phone = phoneDigits.length === 11 && ['7', '8'].includes(phoneDigits[0])
        ? phoneDigits.substring(1)
        : phoneDigits;
      this.newItem.town_id = item.town_id || null;
      if (item.birth_date) {
        this.newItem.passport.birth_date = this.formatDate(this.getDateFromServerString(item.birth_date));
      }
    },
    async getWorker(id) {
      const result = await this.getWorkerById(id);

      if (result.data != null) {
        this.isBusy = false;
        this.loading = false;
        await this.setNewItem(result.data);
      } else {
        this.clearNewItem();
        this.isBusy = false;
        this.loading = false;
      }

      if (this.$refs.worker_costs != null) {
        await this.$refs.worker_costs.configure(this.newItem.id);
      }
    },
    onBack() {
      this.goBack();
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/workers').catch(()=>{});
      }
    },
    clearNewItem() {
      Object.assign(this.newItem, this.makeNewItem());
      this.passportFile = null;
    },
    async setNewItem(item) {
      this.newItem = item;

      if (item.passport == null) {
        this.newItem.passport = this.makePassport();
      } else {
        if (this.newItem.passport.birth_date != null) {
          const birthDate = this.getDateFromServerString(this.newItem.passport.birth_date);
          this.newItem.passport.birth_date = this.formatDate(birthDate);
        }

        if (this.newItem.passport.issue_date != null) {
          const issueDate = this.getDateFromServerString(this.newItem.passport.issue_date);
          this.newItem.passport.issue_date = this.formatDate(issueDate);
        }
      }

      if (this.newItem.active_payment_type != null) {
        const rowIndex = this.newItem.active_payment_type - 1;
        if (this.$refs.paymentTable != null) {
          this.$refs.paymentTable.selectRow(rowIndex);
        }
      }

      if (item.payments_sbp == null) {
        this.newItem.payments_sbp = this.makeSBPPayment();
      }

      if (item.payments_card == null) {
        this.newItem.payments_card = this.makeCardPayment();
      }

      if (item.payments_req == null) {
        this.newItem.payments_req = this.makeReqPayment();
      }

      if (this.newItem.passport_url !== '') {
        const fileName = this.newItem.passport_url.split("/").pop();
        const result = await this.getWorkerFile(this.newItem.id);
        this.passportFile = new File([result.data], fileName);
      }

      if (this.$refs.staff_select != null) {
        if (this.newItem.staff_id != null) {
          await this.$refs.staff_select.configure(this.newItem.staff_id);
        }
      }

      await this.getWorkerBalansProIntegrationHandler();
    },
    async handleSubmit() {
      if (!this.newItem.town_id) {
        this.showSubmitError("Выберите город.");
        return;
      }

      if (!this.newItem.name) {
        this.showSubmitError("Укажите ФИО.");
        return;
      }

      if (this.newItem.worker_source_id === 0) {
        this.showSubmitError("Выберите источник исполнителя.");
        return;
      }

      if (!this.newItem.employment_type) {
        this.showSubmitError("Выберите тип занятости исполнителя.");
        return;
      }

      if (!this.newItem.level_efficiency) {
        this.showSubmitError("Выберите уровень КПД исполнителя.");
        return;
      }

      if (!this.phoneState) {
        this.showSubmitError("Телефон должен состоять только из 10 цифр без пробелов и скобок.");
        return;
      }

      if (this.newItem.passport.birth_date != null) {
        this.newItem.passport.birth_date = this.getDateToServer(this.newItem.passport.birth_date).toISOString();
      }

      if (this.newItem.passport.issue_date != null) {
        this.newItem.passport.issue_date = this.getDateToServer(this.newItem.passport.issue_date).toISOString();
      }

      if (this.$refs.worker_costs != null) {
        if (!this.$refs.worker_costs.items.every(v => v.worker_cost_type_id > 0)) {
          this.showSubmitError("Выберите тип расходов исполнителя.");
          return;
        }

        if (!this.$refs.worker_costs.items.every(v => this.dateValidation(v.start_date))) {
          this.showSubmitError("Введите дату расходов исполнителя.");
          return;
        }

        if (!this.$refs.worker_costs.items.every(v => this.dateValidation(v.end_date))) {
          this.showSubmitError("Введите дату расходов исполнителя.");
          return;
        }

        if (!this.$refs.worker_costs.items.every(v => this.isNumberOrNull(v.sum))) {
          this.showSubmitError("Укажите сумму расходов в виде числа.");
          return;
        }
      }

      this.loading = true;
      this.updateStaffId();
      const data = { ...this.newItem };
      let result;

      if (this.responseId) {
        result = await this.convertResponseToWorker(this.responseId, data);
      } else {
        const method = (data.id > 0) ? this.putWorker : this.postWorker;
        result = await method(data);
      }

      if (result && result.status === 422) {
        this.showError("Исполнитель с таким номером телефона уже существует. Найдите его в базе или введите другой номер телефона.");
        this.loading = false;
        return;
      }

      if (result && result.status === 409) {
        this.showError("Отклик уже связан, не взят вами или был изменён другим пользователем. Обновите список откликов.");
        this.loading = false;
        return;
      }

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;

      if (this.$refs.worker_costs) {
        const costsResult = await this.$refs.worker_costs.saveCosts(this.newItem.id);

        if (costsResult.error != null) {
          this.showSubmitError("Ошибка сохранения расходов.");
          this.loading = false;
          return;
        }
      }

      if (this.passportFile) {
        const fileName = this.getFileName(this.passportFile, "passport");

        let formData = new FormData();
        formData.append('file', this.passportFile, fileName);

        const result = await this.postWorkerPassportFile(this.newItem.id, formData);

        if (result.error) {
          this.showError("Ошибка добавления файла", result.error.message);
          return;
        }

        this.loading = false;
        this.$emit('refresh');

        if (!this.isModal) this.onBack();
      }

      this.loading = false;
      this.$emit('refresh');

      if (!this.isModal) this.onBack();
    },
    getFileName(file, type) {
      const ext = "." + file.name.split('.').pop();
      return type + ext;
    },
    isShowFile(newItem) {
      return newItem.passport_url.length > 0;
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление файла";
      const message = `Вы действительно хотите удалить файл ${this.passportFile.name}?`;
      this.showModalDelete(title, message, function () {
        row.passport_url = '';
        this.passportFile = null;
      }.bind(this));
    },
    async downloadFile() {
      if (!this.newItem.passport_url) return;

      const fileName = this.newItem.passport_url.split("/").pop();
      const result = await this.getWorkerFile(this.newItem.id);

      if (result.error || !result.data) {
        this.showError("Ошибка загрузки файла", result.error.message);
        return;
      }

      this.handleFileDownload(result.data, fileName);
    },
    onPaymentRowSelected(items) {
      if (items.length === 0) {
        this.newItem.active_payment_type = null;
        return;
      }
      this.newItem.active_payment_type = items[0].id;
    },
    isVisibleForRole() {
      return this.hasPermission([PERM.WORKER_READ_OTHER]) || this.hasPermission([PERM.WORKER_EDIT_OTHER]);
    },
    updateStaffId() {
      if (this.$refs.staff_select != null) {
        if (this.$refs.staff_select.item == null) {
          this.newItem.staff_id = null;
          return;
        }

        if (this.$refs.staff_select.item.worker_id != null) {
          if (this.$refs.staff_select.item.worker_id !== this.newItem.id) {
            this.showError("Сотрудник уже связан с другим исполителем");
            this.$refs.staff_select.onClear();
            return;
          }
        }
        this.newItem.staff_id = this.$refs.staff_select.item.id;
      }
    },
    getStaffVariant() {
      return this.newItem.staff_id != null ? 'success' : 'default';
    },

    async getWorkerBalansProIntegrationHandler() {
      const data = {
        id: this.newItem.id
      }
      const result = await this.getWorkerBalansProIntegration(data);
      if (result.error != null) { return; }
      this.workerIntegration = result.data;
    },
    async findBalansProWorkerHandler() {
      const data = {
        //phone: "7" + this.newItem.phone,
        inn: this.innIntegration,
        orgId: this.selectedOrgId,
      }
      const result = await this.getBalansProWorker(data);
      if (result.error != null) {
        this.showError("Не удалось найти исполнителя", result.error.message);
        return;
      }
      const balansProUser = result.data;
      const balansProUserId = balansProUser.user.id;
      const accept = await this.showAcceptLink(balansProUser.user);
      if (accept) {
        await this.linkBalansProWorkerHandler(balansProUserId);
      }
    },
    async showAcceptLink(user) {
      const title = "Связь исполнителя с Баланс Про";
      const message = `
        Исполнитель "${this.newItem.name}" с id ${this.newItem.id}
        будет связан с Баланс Про "${user.full_name}" с id ${user.id}`;
      return await this.showAcceptModal(title, message, 'success');
    },
    async linkBalansProWorkerHandler(balansProId) {
      const data = {
        worker_id: this.newItem.id,
        balans_pro_id: balansProId,
      }
      const result = await this.linkBalansProWorker(data);
      if (result.error != null) {
        this.showError("Ошибка получение данных", result.error.message);
        return;
      }
      this.workerIntegration = result.data
    },
    async prepareUnlinkBalansProWorkerHandler() {
      const accept = await this.showAcceptUnlink();
      if (accept) {
        await this.unlinkBalansProWorkerHandler();
      }
    },
    async showAcceptUnlink() {
      const title = "Отвязка исполнителя от Баланс Про";
      const message = `
        Исполнитель "${this.newItem.name}" c id ${this.newItem.id}
        будет отвязан от Баланс Про с id ${this.workerIntegration.balans_pro_id}`;
      return await this.showAcceptModal(title, message);
    },
    async unlinkBalansProWorkerHandler() {
      const data = {
        id: this.workerIntegration.id
      }
      const result = await this.unlinkBalansProWorker(data);
      if (result.error != null) {
        this.showError("Ошибка получение данных", result.error.message);
        return;
      }
      this.workerIntegration = null;
    },
    onSelectOrg(orgId) {
      this.selectedOrgId = orgId;
    },
    async getLastTasks() {
      if (this.newItem.id == null) { return;}

      const result = await this.getWorkerLastTasks(this.newItem.id);

      if (result && result.data) {
        this.lastTasks = result.data;
      }
    },
    onSelectWorkerStatus(status) {
      if (status) {
        this.$set(this.newItem, 'status_id', status.id);
        this.$set(this.newItem, 'status_name', status.name);
      } else {
        this.$set(this.newItem, 'status_id', null);
        this.$set(this.newItem, 'status_name', '');
      }
    },
    onSelectTown(town) {
      if (town) {
        this.$set(this.newItem, 'town_id', town.id);
        this.$set(this.newItem, 'town_name', town.name);
      } else {
        this.$set(this.newItem, 'town_id', null);
        this.$set(this.newItem, 'town_name', '');
      }
    },
    onSelectWorkerSource(workerSource) {
      if (workerSource) {
        this.$set(this.newItem, 'worker_source_id', workerSource.id);
      } else {
        this.$set(this.newItem, 'worker_source_id', null);
      }
    },
    onSelectEmploymentType(employmentType) {
      if (employmentType) {
        this.$set(this.newItem, 'employment_type', employmentType.value);
      } else {
        this.$set(this.newItem, 'employment_type', null);
      }
    },
    onSelectLevelEfficiency(levelEfficiency) {
      if (levelEfficiency) {
        this.$set(this.newItem, 'level_efficiency', levelEfficiency.value);
      } else {
        this.$set(this.newItem, 'level_efficiency', null);
      }
    }
  },
}
</script>

<style>
.worker-payment-width-selected {
  width: 80px;
  text-align: center;
  vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Workers/Worker.vue